import "../styles/site.css";
import { initialiseShell } from "./shell";

void initialiseShell();
